module.exports = __webpack_public_path__ + "img/carshina21_25.f84ee770.jpg";